import { Heading, HeadingProps, forwardRef } from "@chakra-ui/react";

export const Subheading = forwardRef<HeadingProps, "h2">(
  (props: HeadingProps, ref) => (
    <Heading
      ref={ref}
      size="md"
      color="gray.900"
      textTransform="uppercase"
      {...props}
    />
  )
);
